import { Component, Input } from '@angular/core';
import { SectorHelper } from '../../helpers/sector.helper';

@Component({
  standalone: false,
  selector: 'app-sector-tag',
  templateUrl: './sector-tag.component.html',
  styleUrls: ['./sector-tag.component.scss']
})
export class SectorTagComponent {
  @Input() sectors: Array<any> = [];
  fixedSectors = ['Krojačnica', 'Štamparija', 'Priprema', 'Šivara', 'Vez', 'Pletionica'];

  constructor(private sectorHelper: SectorHelper) {}

  sectorColor(sector: string): string {
    return this.getSectorIndex(sector) !== -1 ? this.sectorHelper.getSectorColor(sector) : '';
  }

  isApprovedSector(sector: string): boolean {
    if (this.sectors) {
      return this.getSectorIndex(sector) !== -1 ? this.sectors[this.getSectorIndex(sector)].operationsListStatus === 'Approved' : false;
    } else {
      return false;
    }
  }

  getSectorIndex(sector: string): number {
    return this.sectors?.findIndex(item => item.name === sector);
  }
}